<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card card-top-line">
          <!-- Header -->
          <div class="header d-flex justify-content-between align-items-center">
            <h2>Checker List</h2>
          </div>
          <div class="body pt-0">
            <!-- Filters/Buttons -->
            <div
              class="chart-top-action d-lg-flex justify-content-end py-3 fresh-customer-filter"
            >
              <!-- SearchBox Filters -->
              <div class="mr-0 mr-lg-3 action-top-search">
                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Keywords"
                    aria-label="Search"
                    v-model="search_keywords"
                    v-on:keyup.enter="searchBin"
                    aria-describedby="search-transactions"
                  />
                  <div class="input-group-append" @click="searchBin()">
                    <span class="input-group-text" id="search-mail">
                      <i class="icon-magnifier"></i>
                    </span>
                  </div>
                </div>
              </div>
              <!-- Toggle Filter Button -->
              <div class="fliter-main mr-auto mt-3 mt-lg-0">
                <!-- <b-button
                  class="fliter-btn btn-lg btn-mw"
                  :variant="isVisibleFilter ? 'primary' : 'outline-primary'"
                  @click="openFilters()"
                >
                  Filters
                  <i class="fa fa-filter" aria-hidden="true"></i>
                </b-button> -->
              </div>
              
            </div>
            <!-- Table Pagination -->
            <div class="py-1 align-items-center justify-content-end table-pagination">
              <div class="number-page">
                <b-pagination
                  class="pagination-small"
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
            </div>
            <!-- Table -->
            <b-table
              responsive
              responsive-class="checker-dropdown-table"
              table-class="mb-0 table-custom border"
              head-variant="light"
              :items="typeof items === 'array' || typeof items === 'object' ? items : []"
              :fields="fields"
              :per-page="perPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="onSortChanged"
              striped
              show-empty
            >
              <template #cell(datetime)="data">
                <strong>{{ data.value | YYYYMMDD }}</strong>
                <small class="text-grey d-block">
                  {{ data.value | TIME }}
                </small>
              </template>

              <template #cell(refid)="data">
                <a
                  href="javascript:void(0);"
                  @click="transactionDetails(data.item)"
                >
                  {{ data.item.refid }}
                </a>
              </template>

              <template #cell(action)="data">
                <b-dropdown
                  id="dropdown-action"
                  text="Actions"
                  right
                  boundary="window"
                  variant="outline-primary"
                  size="sm"
                >
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['reroute.view'])">
                      <b-dropdown-item @click="openViewModal(data.item)">
                          View
                      </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['reroute.update']) && canTakeAction(data.item)">
                      <b-dropdown-item @click="approve(data.item)">
                      Approve
                      </b-dropdown-item>
                  </template>
                  <template v-if="$store.getters['authpermission/hasAnyPermission'](['reroute.update']) && canTakeAction(data.item)">
                      <b-dropdown-item @click="reject(data.item)">
                      Reject
                      </b-dropdown-item>
                  </template>
                </b-dropdown>
              </template>
            </b-table>
            <div
              class="d-flex py-3 align-items-center justify-content-between table-pagination"
            >
              <div class="per-page">
                <b-form-group label="Per page" label-for="per-page-select" class="mb-0">
                  <b-form-select
                    id="per-page-select"
                    v-model="perPage"
                    :options="pageOptions"
                    size="sm"
                  ></b-form-select>
                </b-form-group>
              </div>
              <div class="number-page">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  first-text="First"
                  last-text="Last"
                  :per-page="perPage"
                  align="right"
                ></b-pagination>
              </div>
              <div class="go-page">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">Go To Page</span>
                  </div>
                  <input
                    type="text"
                    v-model="currentPageJump"
                    class="form-control"
                    value=""
                    @keyup.enter="onEnter"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>

    <!-- View Details Modal -->
    <b-modal
      id="view-details-modal"
      v-model="showViewModal"
      title="View Details"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <div v-if="selectedItem" class="modal-content-wrapper">
        <!-- Comparison Table -->
        <div class="mb-4">
          <h6 class="font-weight-bold mb-3">Changes Comparison</h6>
          <div class="table-responsive">
            <b-table
              striped
              bordered
              hover
              class="comparison-table mb-0"
              :items="getComparisonData()"
              :fields="comparisonFields"
              head-variant="light"
            >
              <template #cell(key)="data">
                <strong>{{ data.value }}</strong>
              </template>
              <template #cell(before)="data">
                <span class="value-text">{{ data.value }}</span>
              </template>
              <template #cell(after)="data">
                <span class="value-text highlight-changed">{{ data.value }}</span>
              </template>
            </b-table>
          </div>
        </div>

        <!-- Notes Section -->
        <div class="details-section">
          <h6 class="font-weight-bold mb-3">Notes</h6>
          <div class="notes-box">
            {{ selectedItem.notes || 'No notes available' }}
          </div>
        </div>
        <!--  evidance ref -->
        <div class="details-section">
          <h6 class="font-weight-bold mb-3">Evidence Ref</h6>
          <div class="notes-box">
            {{ selectedItem.evidence || 'No Evidence available' }}
          </div>
        </div>
      </div>

      <template #modal-footer="{ close }">
        <b-button variant="secondary" @click="close()">Close</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ISLOADING } from "../../../store/mutations.type";
const LoaderComponent = require("@/components/admin/loader/LoaderComponent.vue").default;
import { mapGetters } from "vuex";
import {
  GET_CHECKER_LIST,
  UPDATE_CHECKER,
} from "../../../store/actions.type.js";
import { myFunction } from "@/common/common-helper.js";
export default {
  name: "ListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    "main-loader": LoaderComponent,
  },
  data() {
    return {
        breadCrumbIteams: [
            {
            title: "Reroute",
            links: "",
            },
            {
            title: "Checker List",
            links: "",
            },
        ],
        search_keywords: "",
        items: [],
        fields: [
            { key: "datetime", label: "Date", sortable: true },
            { key: "transid", label: "Transaction Id", sortable: true },
            { key: "refid", label: "Trans. Ref", sortable: true },
            { key: "actionType", label: "Action Type", sortable: true },
            { key: "maker", label: "Created By", sortable: true },
            { key: "action", label: "Action" },
        ],
        comparisonFields: [
            { key: "key", label: "Field Name" },
            { key: "before", label: "Before Value" },
            { key: "after", label: "After Value" },
        ],
        totalRows: 1,
        currentPage: 1,
        currentPageJump: 1,
        perPage: 10,
        pageOptions: [10, 20, 50, 100, { value: 1000, text: 1000 }],
        sortBy: "created_at",
        sortDesc: true,
        sortDirection: "asc",
        showViewModal: false,
        selectedItem: null,
        };
    },
    
  methods: {
    searchBin() {
      // Implement search logic
      this.$store.commit(ISLOADING, true);
      this.getCheckerList();
    },
    openViewModal(item) {
      this.selectedItem = item;
      this.showViewModal = true;
    },
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      myFunction.showInfo(`${type} Copied`, "success");
    },
    onSortChanged(ctx) {
      this.sortBy = ctx.sortBy;
      this.sortDesc = ctx.sortDesc;
      if (this.sortBy != "") {
        this.$store.commit(ISLOADING, true);
        this.getCheckerList();
      }
    },
    formatSnapshot(snapshot) {
      if (snapshot === null || snapshot === undefined) {
        return "";
      }
      if (typeof snapshot === "string") {
        return snapshot;
      }
      try {
        return JSON.stringify(snapshot, null, 2);
      } catch (error) {
        return String(snapshot);
      }
    },
    formatKeyName(key) {
      // Replace underscores with spaces and capitalize first letter of each word
      return key
        .replace(/_/g, ' ')
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    },
    getComparisonData() {
      if (!this.selectedItem) {
        return [];
      }

      const beforeObj = this.parseSnapshot(this.selectedItem.before_action);
      const afterObj = this.parseSnapshot(this.selectedItem.after_action);
      
      // Get all unique keys from both objects
      const allKeys = new Set([...Object.keys(beforeObj), ...Object.keys(afterObj)]);
      
      // Create comparison array
      const comparisonData = [];
      allKeys.forEach(key => {
        comparisonData.push({
          key: this.formatKeyName(key),
          before: beforeObj[key] !== undefined ? String(beforeObj[key]) : 'N/A',
          after: afterObj[key] !== undefined ? String(afterObj[key]) : 'N/A',
        });
      });

      // Sort by key name for consistent display
      comparisonData.sort((a, b) => a.key.localeCompare(b.key));
      
      return comparisonData;
    },
    parseSnapshot(snapshot) {
      if (snapshot === null || snapshot === undefined) {
        return {};
      }
      if (typeof snapshot === "string") {
        try {
          return JSON.parse(snapshot);
        } catch (e) {
          return { value: snapshot };
        }
      }
      if (typeof snapshot === "object") {
        return snapshot;
      }
      return { value: String(snapshot) };
    },
    async getCheckerList() {
        let page = "";
        let page_size = "";
        let sortby = "";
        let sort = false;
        if (this.currentPage != undefined) {
            page = this.currentPage;
        } else {
            page = 1;
        }
        if (this.perPage != undefined) {
            page_size = this.perPage;
        } else {
            page_size = 10;
        }
        if (this.sortBy == "") {
            sortby = "created_at";
        } else {
            sortby = this.sortBy;
        }
        if (this.sortDesc == true) {
            sort = "desc";
        } else {
            sort = "asc";
        }

        this.currentPageJump = page;

        let tempparam = `?sort=${sort}&sortby=${sortby}&limit=${page_size}&page=${page}`;
        if (this.search_keywords) {
            tempparam = tempparam + `&search=${this.search_keywords.trimStart()}`;
        }

        const response = await this.$store.dispatch(GET_CHECKER_LIST, tempparam);
        this.items = [];
        const tempitems = [];
        if (response.status == 200) {
            response.data.details.map((item) => {
            tempitems.push({
                id: item.id,
                transid: item.transaction_id,
                refid: item.referenceid,
                actionType: item.action_type,
                maker: item.maker,
                evidence: item.evidence_ref ?? 'N/A',
                maker_user_id: item.maker_user_id,
                before_action: item.before_snapshot,
                after_action: item.after_snapshot,
                notes: item.notes,
                datetime: item.created_at
            });
            });
            this.items = tempitems;
            this.totalRows = response.data.query.total;
        }
    },
    onEnter(e) {
      const paginationMenu = Math.ceil(this.totalRows / this.perPage);
      if (e.target.value > 0) {
        if (paginationMenu >= e.target.value) {
          this.currentPage = this.currentPageJump = Number(e.target.value);
        } else {
          this.currentPage = this.currentPageJump = paginationMenu;
        }
      } else {
        this.currentPage = this.currentPageJump = 1;
      }
    },
    approve(data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
            title: "Are you sure?",
            text: "You want to approve this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, approve it!",
        })
        .then((result) => {
            if (result.isConfirmed) {
              swalWithBootstrapButtons
                .fire({
                  title: "Approve Reason",
                  input: "textarea",
                  inputPlaceholder: "Enter a reason for approval (optional)",
                  inputAttributes: {
                    maxlength: "500",
                    "aria-label": "Checker note",
                  },
                  showCancelButton: true,
                  confirmButtonText: "Submit",
                  cancelButtonText: "Cancel",
                })
                .then((reasonResult) => {
                  if (reasonResult.isConfirmed) {
                    let params = {
                      id: data.id,
                      status: 'APPROVED',
                      checker_note: reasonResult.value || ''
                    };
                    this.updateStatus(params);
                  }
                });
            }
        });
    },

    reject(data) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary btn-lg my-3",
          cancelButton: "btn btn-outline-secondary btn-lg",
        },
        buttonsStyling: false,
      });
      swalWithBootstrapButtons
        .fire({
            title: "Are you sure?",
            text: "You want to reject this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, reject it!",
        })
        .then((result) => {
            if (result.isConfirmed) {
              swalWithBootstrapButtons
                .fire({
                  title: "Reject Reason",
                  input: "textarea",
                  inputPlaceholder: "Enter a reason for rejection (optional)",
                  inputAttributes: {
                    maxlength: "500",
                    "aria-label": "Checker note",
                  },
                  showCancelButton: true,
                  confirmButtonText: "Submit",
                  cancelButtonText: "Cancel",
                })
                .then((reasonResult) => {
                  if (reasonResult.isConfirmed) {
                    let params = {
                      id: data.id,
                      status: 'REJECTED',
                      checker_note: reasonResult.value || ''
                    };
                    this.updateStatus(params);
                  }
                });
            }
        });
    },

    async updateStatus(params){
        this.$store
        .dispatch(UPDATE_CHECKER, params)
        .then((response) => {
        if (response.status == 200) {
            myFunction.showInfo(response.data.message, "success");
            this.$store.commit(ISLOADING, true);
            this.getCheckerList();
        } else {
            myFunction.showInfo(response.data.message, "error");
        }
        })
        .catch((error) => {
            console.error("Error update status:", error);
            myFunction.showInfo(
                "An error occurred while updating the status. Please try again.",
                "error"
            );
        });
    },

    // Maker-checker segregation: a maker may not Approve/Reject their own record
    // unless they are a SuperAdmin. Non-makers (and SuperAdmins) are unaffected.
    canTakeAction(item) {
      if (this.isSuperAdminUser) return true;
      if (!this.currentUserId || item.maker_user_id == null) return true;
      return String(item.maker_user_id) !== String(this.currentUserId);
    },

    // redirect transaction Details
    transactionDetails(data) {
      const route = this.$router.resolve({
        name: "transaction-details",
        params: {
          ref_no: this.$CryptoJS.AES.encrypt(
            data.refid,
            "ref_no",
          ).toString(),
          transaction_id: this.$CryptoJS.AES.encrypt(
            data.transid,
            "transaction_id",
          ).toString(),
        },
      });
      window.open(route.href, "_blank");
    },
  },
  async mounted() {
    this.$store.commit(ISLOADING, true);
    await this.getCheckerList();
  },
  watch: {
    displayFilters() {
      if (
        this.$cookies.get("remitter-list-filter") != null &&
        this.displayFilters.length > 0
      ) {
        this.$store.commit(ISLOADING, true);
        this.getCheckerList();
      }
    },
    currentPage: {
      handler: function () {
        this.$store.commit(ISLOADING, true);
        this.getCheckerList();
      },
    },
    perPage: {
      handler: function () {
        this.$store.commit(ISLOADING, true);
        this.getCheckerList();
      },
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
    isSuperAdminUser() {
      return this.$store.getters["authpermission/hasAnyRole"](["SuperAdmin", "superadmin"]);
    },
    currentUserId() {
      return localStorage.getItem("userid") || null;
    },
  },
};
</script>

<style scoped>
.checker-dropdown-table {
  overflow: visible !important;
}
.checker-dropdown-table .dropdown-menu {
  min-width: 160px;
  white-space: nowrap;
}

.table-custom th,
.table-custom td {
  vertical-align: middle;
}
.text-success {
  color: green;
}
.text-danger {
  color: red;
}
.snapshot-textarea {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 10px;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  resize: vertical;
}
.snapshot-textarea:focus {
  background-color: #fff;
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.notes-box {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  max-height: 150px;
  overflow-y: auto;
  word-wrap: break-word;
}
.details-section {
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 1rem;
}
.details-section:last-child {
  border-bottom: none;
}

/* Comparison Table Styles */
.comparison-table {
  font-size: 13px;
}

.comparison-table thead th {
  background-color: #f8f9fa;
  font-weight: 600;
  color: #333;
  border-color: #dee2e6;
  padding: 10px;
}

.comparison-table tbody td {
  padding: 10px;
  border-color: #dee2e6;
  word-break: break-word;
}

.value-text {
  display: block;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #333;
  word-break: break-word;
  white-space: pre-wrap;
}

.highlight-changed {
  background-color: #fff3cd;
  padding: 4px 6px;
  border-radius: 3px;
}

.table-responsive {
  border-radius: 4px;
  border: 1px solid #dee2e6;
}
</style>
